webpackJsonp([1,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(67);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuexRouterSync = __webpack_require__(69);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _routes = __webpack_require__(18);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _App = __webpack_require__(59);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _vueSortable = __webpack_require__(68);
	
	var _vueSortable2 = _interopRequireDefault(_vueSortable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(45).polyfill();
	
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vueSortable2.default);
	
	
	var router = new _vueRouter2.default({
	  history: true,
	  saveScrollPosition: true,
	  suppressTransitionError: true
	});
	(0, _routes2.default)(router);
	(0, _vuexRouterSync.sync)(_store2.default, router);
	
	router.start(_vue2.default.extend(_App2.default), '#root');
	window.router = router;

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.wxReady = exports.wxConfig = exports.onMenuShareTimeline = exports.onMenuShareAppMessage = exports.weChatAjax = exports.setDocTitle = exports.errorShowAction = exports.updateTodosOrder = exports.deleteTodo = exports.updateTodo = exports.createTodo = exports.getTodos = exports.updateConfigInfo = exports.getConfigInfo = exports.getInitInfo = undefined;
	
	var _api = __webpack_require__(16);
	
	var _api2 = _interopRequireDefault(_api);
	
	var _types = __webpack_require__(3);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getInitInfo = exports.getInitInfo = function getInitInfo(_ref, result) {
	  var dispatch = _ref.dispatch,
	      state = _ref.state;
	
	  dispatch(types.auth.GET_INITINFO, result);
	};
	
	var getConfigInfo = exports.getConfigInfo = function getConfigInfo(_ref2) {
	  var dispatch = _ref2.dispatch,
	      state = _ref2.state;
	
	  dispatch(types.todo.GET_CONFIGINFO_REQ);
	  return _api2.default.getConfigInfo().then(function (response) {
	    dispatch(types.todo.GET_CONFIGINFO, { info: response.data });
	    return response.data;
	  }).catch(function (resp) {
	    dispatch(types.todo.GET_CONFIGINFO_FAIL, { errorMsg: resp.data.message });
	    return resp.data;
	  });
	};
	
	var updateConfigInfo = exports.updateConfigInfo = function updateConfigInfo(_ref3, data) {
	  var dispatch = _ref3.dispatch,
	      state = _ref3.state;
	
	  dispatch(types.todo.UPDATE_CONFIGINFO_REQ);
	  return _api2.default.updateConfigInfo(data).then(function (response) {
	    dispatch(types.todo.UPDATE_CONFIGINFO, { info: response.data });
	    return response;
	  }).catch(function (resp) {
	    dispatch(types.todo.UPDATE_CONFIGINFO_FAIL, { errorMsg: resp.data.message });
	    return resp.data.message;
	  });
	};
	
	var getTodos = exports.getTodos = function getTodos(_ref4, result) {
	  var dispatch = _ref4.dispatch,
	      state = _ref4.state;
	
	  dispatch(types.todo.GET_ALL_REQ);
	  return _api2.default.getTodos().then(function (response) {
	    dispatch(types.todo.GET_ALL, { todos: response.data });
	    return response.data;
	  }).catch(function (resp) {
	    dispatch(types.todo.GET_PRODUCTS_FAIL, { errorMsg: resp.data.message });
	    return resp.data;
	  });
	};
	
	var createTodo = exports.createTodo = function createTodo(_ref5, data) {
	  var dispatch = _ref5.dispatch,
	      state = _ref5.state;
	
	  dispatch(types.todo.CREATE_REQ, data);
	  return _api2.default.createTodo({ content: data }).then(function (response) {
	    dispatch(types.todo.CREATE, { todo: response.data });
	    return response;
	  }).catch(function (resp) {
	    dispatch(types.todo.CREATE_FAIL, { errorMsg: resp.data.message });
	    return resp.data.message;
	  });
	};
	
	var updateTodo = exports.updateTodo = function updateTodo(_ref6, id, data) {
	  var dispatch = _ref6.dispatch,
	      state = _ref6.state;
	
	  dispatch(types.todo.UPDATE_REQ, id, data);
	  return _api2.default.updateTodo(id, data).then(function (response) {
	    dispatch(types.todo.UPDATE, { todo: response.data, id: id });
	    return response;
	  }).catch(function (resp) {
	    dispatch(types.todo.UPDATE_FAIL, { errorMsg: resp.data.message });
	    return resp.data.message;
	  });
	};
	
	var deleteTodo = exports.deleteTodo = function deleteTodo(_ref7, id) {
	  var dispatch = _ref7.dispatch,
	      state = _ref7.state;
	
	  dispatch(types.todo.DELETE_REQ, id);
	  return _api2.default.deleteTodo(id).then(function (response) {
	    dispatch(types.todo.DELETE, { id: id });
	    return true;
	  }).catch(function (resp) {
	    dispatch(types.todo.DELETE_FAIL, { errorMsg: resp.data.message });
	    return resp.data.message;
	  });
	};
	
	var updateTodosOrder = exports.updateTodosOrder = function updateTodosOrder(_ref8, data) {
	  var dispatch = _ref8.dispatch,
	      state = _ref8.state;
	
	  dispatch(types.todo.UPDATE_ORDER_REQ);
	  return _api2.default.updateTodoOrder({ ids: data }).then(function (response) {
	    dispatch(types.todo.UPDATE_ORDER, { todos: response.data });
	    return true;
	  }).catch(function (resp) {
	    dispatch(types.todo.UPDATE_ORDER_FAIL, { errorMsg: resp.data.message });
	    return resp.data.message;
	  });
	};
	
	var errorShowAction = exports.errorShowAction = function errorShowAction(_ref9, errorInfo) {
	  var dispatch = _ref9.dispatch,
	      state = _ref9.state;
	
	  dispatch(types.error.SHOW, errorInfo);
	  setTimeout(function () {
	    dispatch(types.error.HIDE);
	  }, 3000);
	};
	
	var setDocTitle = exports.setDocTitle = function setDocTitle(_ref10, title) {
	  var dispatch = _ref10.dispatch;
	  var addCompanyName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  dispatch(types.global.SET_TITLE, title, addCompanyName);
	};
	
	var weChatAjax = exports.weChatAjax = function weChatAjax() {
	  return _api2.default.wxAjax().then(function (response) {
	    return response;
	  });
	};
	
	var onMenuShareAppMessage = exports.onMenuShareAppMessage = function onMenuShareAppMessage(title, url, content) {
	  wx.onMenuShareAppMessage({
	    title: title,
	    desc: content,
	    link: url,
	    imgUrl: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
	    success: function success() {},
	    cancel: function cancel() {}
	  });
	};
	
	var onMenuShareTimeline = exports.onMenuShareTimeline = function onMenuShareTimeline(url, content) {
	  wx.onMenuShareTimeline({
	    title: content,
	    link: url,
	    imgUrl: 'https://oaaqymp5v.qnssl.com/todo/152icon.png ',
	    success: function success() {},
	    cancel: function cancel() {}
	  });
	};
	
	var wxConfig = exports.wxConfig = function wxConfig(resp) {
	  wx.config({
	    debug: false,
	    appId: resp.app_id,
	    timestamp: resp.timestamp,
	    nonceStr: resp.noncestr,
	    signature: resp.signature,
	    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage']
	  });
	};
	
	var wxReady = exports.wxReady = function wxReady(func) {
	  wx.ready(func);
	};

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.auth = exports.error = exports.todo = exports.global = undefined;
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resourceMaker = function resourceMaker() {
	  var ajaxResources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var normalResources = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	
	  var ret = _lodash2.default.reduce(ajaxResources, function (ret, val) {
	    ret['' + val] = '' + prefix + val;
	    ret[val + '_REQ'] = '' + prefix + val + '_REQ';
	    ret[val + '_FAIL'] = '' + prefix + val + '_FAIL';
	    return ret;
	  }, {});
	
	  ret = _lodash2.default.reduce(normalResources, function (ret, val) {
	    ret['' + val] = '' + prefix + val;
	    return ret;
	  }, ret);
	
	  return ret;
	};
	
	var global = exports.global = resourceMaker([], ['SET_TITLE']);
	
	var todo = exports.todo = resourceMaker(['GET_CONFIGINFO', 'UPDATE_CONFIGINFO', 'CREATE', 'DELETE', 'UPDATE', 'UPDATE_ORDER', 'GET_ALL'], 'TODO_');
	
	var error = exports.error = resourceMaker([], ['SHOW', 'HIDE'], 'ERROR_');
	
	var auth = exports.auth = resourceMaker([], ['GET_INITINFO'], 'AUTH_');

/***/ },
/* 4 */,
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vuex = __webpack_require__(70);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	var _logger = __webpack_require__(71);
	
	var _logger2 = _interopRequireDefault(_logger);
	
	var _global = __webpack_require__(21);
	
	var _global2 = _interopRequireDefault(_global);
	
	var _auth = __webpack_require__(20);
	
	var _auth2 = _interopRequireDefault(_auth);
	
	var _todo = __webpack_require__(22);
	
	var _todo2 = _interopRequireDefault(_todo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuex2.default);
	
	var isPro = 1 || ("production") == 'production';
	var isDebug = 0 || !isPro;
	var applicationId = 1000010;
	
	_vue2.default.config.debug = isDebug;
	
	exports.default = new _vuex2.default.Store({
	  modules: {
	    global: _global2.default,
	    auth: _auth2.default,
	    todo: _todo2.default
	  },
	  state: { isPro: isPro, isDebug: isDebug, applicationId: applicationId },
	  strict: isDebug,
	  middlewares: isDebug ? [(0, _logger2.default)()] : []
	});

/***/ },
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(25)
	__vue_template__ = __webpack_require__(52)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(31)
	__vue_template__ = __webpack_require__(58)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _resource = __webpack_require__(17);
	
	exports.default = {
	  getConfigInfo: _resource.TodoResource.getConfigInfo,
	  updateConfigInfo: _resource.TodoResource.updateConfigInfo,
	  createTodo: _resource.TodoResource.createTodo,
	  updateTodo: _resource.TodoResource.updateTodo,
	  deleteTodo: _resource.TodoResource.deleteTodo,
	  getTodos: _resource.TodoResource.getTodos,
	  updateTodoOrder: _resource.TodoResource.updateTodoOrder,
	  wxAjax: _resource.TodoResource.wxAjax
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.StatResource = exports.TodoResource = undefined;
	
	var _stringify = __webpack_require__(10);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(9);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueResource = __webpack_require__(66);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isPro = _store2.default.state.isPro;
	var API_ROOT = isPro ? 'https://app11007.huoban.com/api/' : 'http://app11007.dev.huoban.com/api/';
	
	_vue2.default.use(_vueResource2.default);
	
	_vue2.default.http.options.crossOrigin = true;
	_vue2.default.http.options.xhr = { withCredentials: true };
	
	_vue2.default.http.interceptors.push({
	  request: function request(_request) {
	    _request.headers = _request.headers || {};
	    if (!_request.headers.Authorization) {
	      if (_store2.default.state.auth.ticket && _request.url.indexOf(API_ROOT) === 0) {
	        _request.headers['X-Huoban-Ticket'] = _store2.default.state.auth.ticket;
	        _request.headers['X-Huoban-App-Id'] = _store2.default.state.auth.appId;
	        _request.headers['X-Huoban-Table-Id'] = _store2.default.state.auth.tableId;
	      } else {
	        _request.headers['X-Huoban-E'] = '' + _store2.default.router.app.$route.params.id;
	      }
	    }
	    return _request;
	  },
	  response: function response(_response) {
	    return _response;
	  }
	});
	
	var TodoResource = exports.TodoResource = {
	  getConfigInfo: function getConfigInfo() {
	    return _vue2.default.http.get(API_ROOT + 'config');
	  },
	  updateConfigInfo: function updateConfigInfo(data) {
	    return _vue2.default.http.put(API_ROOT + 'config', data);
	  },
	  getTodos: function getTodos() {
	    return _vue2.default.http.get(API_ROOT + 'todos');
	  },
	  createTodo: function createTodo(data) {
	    return _vue2.default.http.post(API_ROOT + 'todo', data);
	  },
	  updateTodo: function updateTodo(id, data) {
	    return _vue2.default.http.put(API_ROOT + ('todo/' + id), data);
	  },
	  deleteTodo: function deleteTodo(id) {
	    return _vue2.default.http.delete(API_ROOT + ('todo/' + id));
	  },
	  updateTodoOrder: function updateTodoOrder(data) {
	    return _vue2.default.http.post(API_ROOT + 'order/todos', data);
	  },
	  wxAjax: function wxAjax() {
	    return _vue2.default.http.post('https://api.huoban.com/v1/auth/wechat/mp_signature', (0, _stringify2.default)({ url: location.href }), {
	      headers: {
	        Authorization: 'Bearer y1npyvEPe6iM9xiZzjr69bn81XXlPRnHT0xrcZtP'
	      }
	    });
	  }
	};
	
	var StatResource = exports.StatResource = {
	  statUserAction: function statUserAction(data) {
	    var StatOptions = {
	      headers: {
	        'X-Huoban-Ticket': _store2.default.state.auth.ticket
	      }
	    };
	    return _vue2.default.http.post('https://api.huoban.com/v2/log', data, StatOptions);
	  }
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (router, store) {
	  router.map({
	    '/': {
	      name: 'home',
	      displayName: '清单',
	      component: __webpack_require__(15),
	      subRoutes: {}
	    },
	    '/error': {
	      name: 'error',
	      component: __webpack_require__(65)
	    },
	    '/e/:id': {
	      name: 'share',
	      component: __webpack_require__(15)
	    }
	  });
	
	  router.alias({
	    '/index': '/'
	  });
	
	  router.redirect({
	    '*': '/' });
	};

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var nl2br = exports.nl2br = function nl2br(str) {
	  var breakTag = '<br ' + '/>';
	  return (str || '' + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
	};

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  user: null,
	  ticket: null,
	  table: null,
	  appId: null,
	  tableId: null
	};
	
	var mutations = (0, _defineProperty3.default)({}, _types.auth.GET_INITINFO, function (state, initInfo) {
	  state.user = initInfo.user;
	  state.ticket = initInfo.ticket;
	  state.table = initInfo.table;
	  state.appId = initInfo.app_id || initInfo.appId;
	  state.tableId = initInfo.table.table_id || initInfo.table.app_id;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _types = __webpack_require__(3);
	
	var types = _interopRequireWildcard(_types);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SET_TITLE = types.global.SET_TITLE;
	
	
	var companyName = '极简清单';
	
	var refreshTitle = function refreshTitle(title) {
	  $('<iframe width="0" height="0" src=\'https://app.huoban.com/favicon.ico\' style="display: none"></iframe>').one('load', function (e) {
	    var _this = this;
	
	    setTimeout(function (n) {
	      return _this.parentNode.removeChild(_this);
	    }, 0);
	  }).appendTo(document.body);
	};
	
	var state = {
	  docTitle: ''
	};
	
	var mutations = (0, _defineProperty3.default)({}, SET_TITLE, function (state, title, addName) {
	  var arr = (title ? [].concat(title) : []).concat(addName ? companyName : []);
	  var tt = arr.join('_') || companyName;
	
	  document.title = tt;
	  if (state.isInWechat && state.isIPhone) {
	    refreshTitle(tt);
	  }
	
	  state.docTitle = tt;
	});
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(6);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _mutations;
	
	var _types = __webpack_require__(3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var state = {
	  isLoading: true,
	  isLoadingList: true,
	  isRequestError: false,
	  errorMsg: '',
	  isSubmitting: false,
	  isDeleting: false,
	  configInfo: {},
	  newTodo: null,
	  todoList: [],
	  errorShow: false,
	  errorInfo: '',
	  oldIds: [],
	  isCreate: false
	};
	
	var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _types.todo.GET_ALL, function (state, _ref) {
	  var todos = _ref.todos;
	
	  state.isLoadingList = false;
	  state.todoList = [];
	  state.todoList = todos;
	  state.todoList.forEach(function (item) {
	    state.oldIds.push(item.id);
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.GET_ALL_REQ, function (state) {
	  state.isLoadingList = true;
	  state.errorMsg = '';
	  state.isRequestError = false;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.GET_ALL_FAIL, function (state, _ref2) {
	  var errorMsg = _ref2.errorMsg;
	
	  state.isLoadingList = false;
	  state.isRequestError = true;
	  state.errorMsg = errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.GET_CONFIGINFO, function (state, _ref3) {
	  var info = _ref3.info;
	
	  state.isLoading = false;
	  state.isRequestError = false;
	  state.errorMsg = '';
	  state.configInfo = info;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.GET_CONFIGINFO_REQ, function (state) {
	  state.isRequestError = false;
	  state.errorMsg = '';
	  state.isLoading = true;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.GET_CONFIGINFO_FAIL, function (state, _ref4) {
	  var errorMsg = _ref4.errorMsg;
	
	  state.isLoading = false;
	  state.isRequestError = true;
	  state.errorMsg = errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_CONFIGINFO_REQ, function (state) {
	  state.isSubmitting = true;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_CONFIGINFO, function (state, _ref5) {
	  var info = _ref5.info;
	
	  state.isSubmitting = false;
	  state.configInfo = info;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_CONFIGINFO_FAIL, function (state, _ref6) {
	  var errorMsg = _ref6.errorMsg;
	
	  state.isSubmitting = false;
	  state.errorMsg = errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.CREATE_REQ, function (state, data) {
	  state.isSubmitting = true;
	  state.todoList.push({
	    id: -1,
	    todo_content: data,
	    todo_status: 'uncompleted'
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.CREATE, function (state, _ref7) {
	  var todo = _ref7.todo;
	
	  state.isSubmitting = false;
	  state.newTodo = todo;
	  state.todoList.forEach(function (item) {
	    if (item.id == -1) {
	      item.id = todo.id;
	    }
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.CREATE_FAIL, function (state, _ref8) {
	  var errorMsg = _ref8.errorMsg;
	
	  state.isSubmitting = false;
	  state.errorMsg = errorMsg;
	  state.isRequestError = true;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_REQ, function (state, id, data) {
	  state.isSubmitting = true;
	  _.forEach(state.todoList, function (item) {
	    if (id == item.id && data.status) {
	      item.todo_status = data.status;
	    }
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE, function (state, _ref9) {
	  var todo = _ref9.todo;
	
	  state.isSubmitting = false;
	  _.forEach(state.todoList, function (item) {
	    if (item.id == todo.id) {
	      item = todo;
	    }
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_FAIL, function (state, _ref10) {
	  var errorMsg = _ref10.errorMsg;
	
	  state.isSubmitting = false;
	  state.errorMsg = errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.DELETE_REQ, function (state, id) {
	  state.todoList.forEach(function (item, index) {
	    if (item.id == id) {
	      state.todoList.splice(index, 1);
	    }
	  });
	}), (0, _defineProperty3.default)(_mutations, _types.todo.DELETE, function (state) {
	  state.isDeleting = false;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.DELETE_FAIL, function (state, _ref11) {
	  var errorMsg = _ref11.errorMsg;
	
	  state.isDeleting = false;
	  state.errorMsg = errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_ORDER, function (state, _ref12) {
	  var todos = _ref12.todos;
	
	  state.isSubmitting = false;
	  state.todoList = todos;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_ORDER_REQ, function (state) {
	  state.errorMsg = '';
	  state.isRequestError = false;
	  state.isSubmitting = true;
	}), (0, _defineProperty3.default)(_mutations, _types.todo.UPDATE_ORDER_FAIL, function (state, data) {
	  state.isSubmitting = false;
	  state.isRequestError = true;
	  state.errorMsg = data.errorMsg;
	}), (0, _defineProperty3.default)(_mutations, _types.error.ERROR_SHOW, function (state, info) {
	  state.errorShow = true;
	  state.errorInfo = info;
	}), (0, _defineProperty3.default)(_mutations, _types.error.ERROR_HIDE, function (state) {
	  state.errorShow = false;
	}), _mutations);
	
	exports.default = {
	  state: state,
	  mutations: mutations
	};

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(10);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _actions = __webpack_require__(2);
	
	var _store = __webpack_require__(5);
	
	var _store2 = _interopRequireDefault(_store);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  replace: true,
	  store: _store2.default,
	  components: {},
	  vuex: {
	    actions: {
	      getInitInfo: _actions.getInitInfo
	    }
	  },
	  data: function data() {
	    return {
	      isRender: false
	    };
	  },
	  ready: function ready() {
	    var _this = this;
	
	    if (this.$route.name === 'share') {
	      this.isRender = true;
	    } else {
	      this.client = window.HuobanAppSDK.client();
	      this.client.on('error.connect', function (err) {
	        _this.isRender = true;
	        _this.$router.go({ name: 'error', query: { type: 'error', routerName: 'home' } });
	      });
	      this.client.init(11007).then(function (ret) {
	        _this.isRender = true;
	        if (ret.table && ret.ticket) {
	          _this.getInitInfo(ret);
	        } else {
	          _this.$router.go({ name: 'error', query: { type: 'error', routerName: 'home' } });
	        }
	      }).catch(function (err) {
	        var info = {
	          err: err,
	          isPC: window.HuobanAppSDK.isPC,
	          isWap: window.HuobanAppSDK.isWap,
	          isAndroid: window.HuobanAppSDK.isAndroid,
	          isClient: window.HuobanAppSDK.isClient,
	          cookie: document.cookie
	        };
	        alert('init fail:' + (0, _stringify2.default)(info));
	        _this.isRender = true;
	        _this.$router.go({ name: 'error', query: { type: 'error', routerName: 'home' } });
	      });
	    }
	  }
	};

/***/ },
/* 24 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'error-tip',
	  props: ['show', 'info']
	};

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'input-box',
	
	  props: {
	    text: String,
	    preventKeys: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return '';
	      }
	    },
	    isFinished: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    itemId: Number,
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      focused: false,
	      _text: '',
	      _lastText: '',
	      isEdit: false,
	      info: {}
	    };
	  },
	
	
	  methods: {
	    handlePaste: function handlePaste(evt) {
	      evt.preventDefault();
	      var data = evt.clipboardData.getData('text/plain');
	      var selection = window.getSelection();
	      var range = selection.getRangeAt(0);
	      range.deleteContents();
	      var fragment = range.createContextualFragment('');
	      fragment.textContent = data;
	      var replacementEnd = fragment.lastChild;
	      range.insertNode(fragment);
	
	      range.setStartAfter(replacementEnd);
	      range.collapse(true);
	      selection.removeAllRanges();
	      selection.addRange(range);
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	      var el = this.$els.c;
	      if (evt.keyCode == 13) {
	        this.dispatch(false);
	        this.focused = false;
	        this.$els.c.innerHTML = this.getDisplayValue();
	        window.getSelection().removeAllRanges();
	      }
	      if (evt.keyCode == 8) {
	        this.info = {
	          html: el.innerHTML,
	          length: el.innerHTML.length,
	          isBr: el.innerHTML == '<br>'
	        };
	        if (el.innerHTML == '' || el.innerHTML == '<br>') {
	
	          this.dispatch(false);
	        }
	      }
	      var forbiddenKeys = [66, 73];
	
	      if ((evt.ctrlKey || evt.metaKey) && forbiddenKeys.indexOf(evt.keyCode) > -1) {
	        evt.preventDefault();
	        evt.stopPropagation();
	      }
	    },
	    handleKeyPress: function handleKeyPress(evt) {},
	    handleFocus: function handleFocus() {
	      this.focused = true;
	      this.$els.c.innerHTML = this.getDisplayValue();
	    },
	    handleBlur: function handleBlur() {
	      this.dispatch(true);
	      this.focused = false;
	      this.$els.c.innerHTML = this.getDisplayValue();
	      window.getSelection().removeAllRanges();
	    },
	    handleClick: function handleClick() {},
	    setEndOfContenteditable: function setEndOfContenteditable(contentEditableElement) {
	      var range, selection;
	      if (document.createRange) {
	        range = document.createRange();
	        range.selectNodeContents(contentEditableElement);
	        range.collapse(false);
	        selection = window.getSelection();
	        selection.removeAllRanges();
	        selection.addRange(range);
	      } else if (document.selection) {
	        range = document.body.createTextRange();
	        range.moveToElementText(contentEditableElement);
	        range.collapse(false);
	        range.select();
	      }
	    },
	    dispatch: function dispatch(isBlur) {
	      this._text = this.$els.c.innerText.replace(/[\n\r\t]/g, '');
	      this.$dispatch('input-box-change', this._text, isBlur);
	    },
	    getDisplayValue: function getDisplayValue() {
	      var escapeText = _lodash2.default.escape(this._text);
	
	      escapeText = escapeText.replace(/[\n\r\t]/g, '');
	      var ret = escapeText;
	      if (!this.focused) {
	        ret = escapeText;
	      }
	      return ret;
	    },
	    updateDisplayValue: function updateDisplayValue() {
	      var value = this.getDisplayValue();
	
	      if (!this.focused) {
	        this.$els.c.innerHTML = value;
	      }
	    },
	    debounceDispatch: function debounceDispatch() {
	      var _this = this;
	
	      return _lodash2.default.debounce(function (text) {
	        _this.$dispatch('input-box-change', text);
	      }, 500);
	    },
	    restoreValue: function restoreValue() {
	      this._text = this._lastText;
	      this.updateDisplayValue();
	    }
	  },
	
	  watch: {
	    text: function text(newValue, oldValue) {
	      this._text = newValue;
	      this._lastText = newValue;
	      this.updateDisplayValue();
	    }
	  },
	
	  ready: function ready() {
	    this._text = this.text;
	    this._lastText = this.text;
	    this.updateDisplayValue();
	  },
	
	
	  events: {
	    'input-focus': function inputFocus(_index) {
	      if (this.index == _index) {
	        setTimeout(function () {
	          this.$el.focus();
	          this.setEndOfContenteditable(this.$el);
	        }.bind(this), 1);
	      }
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {}
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'todo-create',
	
	  props: {
	    text: String,
	    preventKeys: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return '';
	      }
	    },
	    isFinished: {
	      type: Boolean,
	      default: function _default() {
	        return false;
	      }
	    },
	    itemId: Number
	  },
	
	  data: function data() {
	    return {
	      focused: false,
	      _text: '',
	      _lastText: '',
	      isEdit: false,
	      info: {}
	    };
	  },
	
	
	  methods: {
	    handlePaste: function handlePaste(evt) {
	      evt.preventDefault();
	      var data = evt.clipboardData.getData('text/plain');
	      var selection = window.getSelection();
	      var range = selection.getRangeAt(0);
	      range.deleteContents();
	      var fragment = range.createContextualFragment('');
	      fragment.textContent = data;
	      var replacementEnd = fragment.lastChild;
	      range.insertNode(fragment);
	
	      range.setStartAfter(replacementEnd);
	      range.collapse(true);
	      selection.removeAllRanges();
	      selection.addRange(range);
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	      var el = this.$els.c;
	      if (evt.keyCode == 13) {
	        el.blur();
	      }
	      var forbiddenKeys = [66, 73];
	
	      if ((evt.ctrlKey || evt.metaKey) && forbiddenKeys.indexOf(evt.keyCode) > -1) {
	        evt.preventDefault();
	        evt.stopPropagation();
	      }
	    },
	    handleKeyPress: function handleKeyPress(evt) {},
	    handleFocus: function handleFocus() {
	      this.focused = true;
	    },
	    handleBlur: function handleBlur() {
	      this.dispatch();
	      this.focused = true;
	      this.$els.c.innerHTML = '';
	      window.getSelection().removeAllRanges();
	    },
	    handleClick: function handleClick() {},
	    setEndOfContenteditable: function setEndOfContenteditable(contentEditableElement) {
	      var range, selection;
	      if (document.createRange) {
	        range = document.createRange();
	        range.selectNodeContents(contentEditableElement);
	        range.collapse(false);
	        selection = window.getSelection();
	        selection.removeAllRanges();
	        selection.addRange(range);
	      } else if (document.selection) {
	        range = document.body.createTextRange();
	        range.moveToElementText(contentEditableElement);
	        range.collapse(false);
	        range.select();
	      }
	    },
	    dispatch: function dispatch() {
	      this._text = this.$els.c.innerText.replace(/[\n\r\t]/g, '');
	      this.$dispatch('input-box-change', this._text);
	    },
	    getDisplayValue: function getDisplayValue() {
	      var escapeText = _lodash2.default.escape(this._text);
	
	      escapeText = escapeText.replace(/[\n\r\t]/g, '');
	      var ret = escapeText;
	      if (!this.focused) {
	        ret = escapeText;
	      }
	      return ret;
	    },
	    updateDisplayValue: function updateDisplayValue() {
	      var value = this.getDisplayValue();
	
	      if (!this.focused) {
	        this.$els.c.innerHTML = value;
	      }
	    },
	    debounceDispatch: function debounceDispatch() {
	      var _this = this;
	
	      return _lodash2.default.debounce(function (text) {
	        _this.$dispatch('input-box-change', text);
	      }, 500);
	    },
	    restoreValue: function restoreValue() {
	      this._text = this._lastText;
	      this.updateDisplayValue();
	    }
	  },
	
	  watch: {
	    text: function text(newValue, oldValue) {
	      this._text = newValue;
	      this._lastText = newValue;
	      this.updateDisplayValue();
	    }
	  },
	
	  ready: function ready() {
	    this._text = this.text;
	    this._lastText = this.text;
	    this.updateDisplayValue();
	  },
	  beforeDestroy: function beforeDestroy() {},
	
	
	  events: {
	    'create-succeed': function createSucceed() {
	      setTimeout(function () {
	        this.$el.focus();
	        this.setEndOfContenteditable(this.$el);
	      }.bind(this), 1);
	    }
	  }
	};

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inputBox = __webpack_require__(14);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	var _actions = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	  name: 'todo-item',
	
	  components: {
	    InputBox: _inputBox2.default
	  },
	
	  vuex: {
	    actions: {
	      deleteTodo: _actions.deleteTodo,
	      updateTodo: _actions.updateTodo
	    }
	  },
	
	  props: {
	    item: Object,
	    index: Number
	  },
	
	  data: function data() {
	    return {
	      isFinished: this.item.todo_status == 'completed'
	    };
	  },
	
	
	  computed: {},
	  methods: {
	    handleClick: function handleClick() {
	      this.isFinished = !this.isFinished;
	
	      var status = this.item.todo_status == 'completed' ? 'uncompleted' : 'completed';
	      this.updateTodo(this.item.id, {
	        status: status
	      });
	    },
	    handleInputBoxChange: function handleInputBoxChange(text, isBlur) {
	      if (text == '' || text == '<br>') {
	        this.deleteTodo(this.item.id);
	        this.$dispatch('delete-succeed', this.index);
	      } else {
	        this.updateTodo(this.item.id, {
	          content: text
	        });
	        this.$dispatch('update-succeed', this.index, isBlur);
	      }
	    }
	  }
	};

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _todoItem = __webpack_require__(62);
	
	var _todoItem2 = _interopRequireDefault(_todoItem);
	
	var _inputBox = __webpack_require__(14);
	
	var _inputBox2 = _interopRequireDefault(_inputBox);
	
	var _todoCreate = __webpack_require__(61);
	
	var _todoCreate2 = _interopRequireDefault(_todoCreate);
	
	var _actions = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'todo-list',
	  components: {
	    TodoItem: _todoItem2.default,
	    InputBox: _inputBox2.default,
	    TodoCreate: _todoCreate2.default
	  },
	
	  vuex: {
	    getters: {
	      todoList: function todoList(state) {
	        return state.todo.todoList;
	      },
	      isLoadingList: function isLoadingList(state) {
	        return state.todo.isLoadingList;
	      },
	      oldIds: function oldIds(state) {
	        return state.todo.oldIds;
	      }
	    },
	    actions: {
	      getTodos: _actions.getTodos,
	      createTodo: _actions.createTodo,
	      updateTodosOrder: _actions.updateTodosOrder
	    }
	  },
	
	  ready: function ready() {
	    this.getTodos();
	  },
	  data: function data() {
	    return {
	      sortOption: {
	        sort: true,
	        animation: 150,
	        onStart: this.handleSortStart,
	        onEnd: this.handleSortEnd,
	        ghostClass: 'ghost',
	        handle: '.drag',
	        delay: window.HuobanAppSDK.isMobile ? 200 : 0
	      },
	      isCover: false
	    };
	  },
	
	
	  computed: {},
	  methods: {
	    handleSortEnd: function handleSortEnd(evt) {
	      var _this = this;
	
	      if (evt.newIndex && evt.newIndex != evt.oldIndex) {
	        (function () {
	          _this.computeCoverAttr();
	          _this.isCover = true;
	          var idList = [];
	          _this.todoList.forEach(function (item) {
	            idList.push(item.id);
	          });
	          var tempId = idList.splice(evt.oldIndex, 1)[0];
	          idList.splice(evt.newIndex, 0, tempId);
	          if (idList.join('') != _this.oldIds.join('')) {
	            _this.updateTodosOrder(idList).then(function () {
	              _this.isCover = false;
	            });
	          }
	        })();
	      }
	    },
	    handleSortStart: function handleSortStart(evt) {
	      console.log(evt.item);
	    },
	    handleInputBoxChange: function handleInputBoxChange(text) {
	      if (text != '') {
	        this.createTodo(text);
	        this.$broadcast('create-succeed');
	      }
	    },
	    computeCoverAttr: function computeCoverAttr() {
	      var sortElePosition = $(this.$els.sortList).position();
	      $(this.$els.coverEle).width($(this.$els.sortList).width());
	      $(this.$els.coverEle).height($(this.$els.sortList).height());
	      $(this.$els.coverEle).css({
	        left: sortElePosition.left,
	        top: sortElePosition.top
	      });
	    },
	    handleOperateSucceed: function handleOperateSucceed(index, isBlur) {
	      if (!isBlur && index < this.todoList.length) {
	        this.$broadcast('input-focus', index + 1);
	      }
	    }
	  }
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _functions = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'todo-title',
	  props: {
	    text: String,
	    placeholder: {
	      type: String,
	      default: function _default() {
	        return '';
	      }
	    }
	  },
	
	  data: function data() {
	    return {
	      focused: false,
	      _text: '',
	      _lastText: ''
	    };
	  },
	
	
	  methods: {
	    handlePaste: function handlePaste(evt) {
	      evt.preventDefault();
	      var data = evt.clipboardData.getData('text/plain');
	      var selection = window.getSelection();
	      var range = selection.getRangeAt(0);
	      range.deleteContents();
	      var fragment = range.createContextualFragment('');
	      fragment.textContent = data;
	      var replacementEnd = fragment.lastChild;
	      range.insertNode(fragment);
	
	      range.setStartAfter(replacementEnd);
	      range.collapse(true);
	      selection.removeAllRanges();
	      selection.addRange(range);
	    },
	    handleKeyDown: function handleKeyDown(evt) {
	      if (!this.isFinished) {
	        if (evt.keyCode == 13) {
	          this.$el.blur();
	        }
	        if (evt.keyCode == 8) {
	          this.dispatch();
	        }
	      } else {
	        evt.preventDefault();
	      }
	      var forbiddenKeys = [66, 73];
	
	      if ((evt.ctrlKey || evt.metaKey) && forbiddenKeys.indexOf(evt.keyCode) > -1) {
	        evt.preventDefault();
	        evt.stopPropagation();
	      }
	    },
	    handleKeyPress: function handleKeyPress(evt) {},
	    handleFocus: function handleFocus() {
	      this.focused = true;
	      this.$el.innerHTML = this.getDisplayValue();
	    },
	    handleBlur: function handleBlur() {
	      this.dispatch();
	      this.focused = false;
	      this.$el.innerHTML = this.getDisplayValue();
	      window.getSelection().removeAllRanges();
	    },
	    dispatch: function dispatch() {
	      this._text = this.$el.innerText;
	      this.$dispatch('title-box-change', this._text);
	    },
	    getDisplayValue: function getDisplayValue() {
	      var escapeText = _lodash2.default.escape(this._text);
	      escapeText = (0, _functions.nl2br)(escapeText);
	      var ret = escapeText;
	      if (!this.focused) {
	        ret = escapeText || this.placeholder;
	      }
	      return ret;
	    },
	    updateDisplayValue: function updateDisplayValue() {
	      var value = this.getDisplayValue();
	
	      if (!this.focused) {
	        this.$el.innerHTML = value;
	      }
	    },
	    debounceDispatch: function debounceDispatch() {
	      var _this = this;
	
	      return _lodash2.default.debounce(function (text) {
	        _this.$dispatch('title-box-change', text);
	      }, 500);
	    },
	    restoreValue: function restoreValue() {
	      this._text = this._lastText;
	      this.updateDisplayValue();
	    }
	  },
	
	  watch: {
	    text: function text(newValue, oldValue) {
	      this._text = newValue;
	      this._lastText = newValue;
	      this.updateDisplayValue();
	    }
	  },
	
	  ready: function ready() {
	    this._text = this.text;
	    this._lastText = this.text;
	    this.updateDisplayValue();
	  },
	  beforeDestroy: function beforeDestroy() {}
	};

/***/ },
/* 30 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'error',
	  methods: {
	    backToPrevRouter: function backToPrevRouter() {
	      this.$router.go({ name: this.$route.query.routerName });
	    }
	  }
	};

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(2);
	
	var _todoList = __webpack_require__(63);
	
	var _todoList2 = _interopRequireDefault(_todoList);
	
	var _todoTitle = __webpack_require__(64);
	
	var _todoTitle2 = _interopRequireDefault(_todoTitle);
	
	var _errorTip = __webpack_require__(60);
	
	var _errorTip2 = _interopRequireDefault(_errorTip);
	
	var _lodash = __webpack_require__(1);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'todo-home',
	  components: {
	    TodoList: _todoList2.default,
	    TodoTitle: _todoTitle2.default,
	    ErrorTip: _errorTip2.default
	  },
	
	  data: function data() {
	    var isWeChat = navigator.userAgent.indexOf('MicroMessenger') > 0;
	    var isShare = this.$route.name === 'share';
	    return {
	      qrcode: '',
	      isShowDialog: false,
	      hasCreate: false,
	      isShowQrcode: false,
	      showMask: false,
	      isMobile: window.HuobanAppSDK.isMobile,
	      isPC: window.HuobanAppSDK.isPC,
	      isWeChat: isWeChat,
	      isShare: isShare,
	      showCreateList: !window.HuobanAppSDK.isClient && window.HuobanAppSDK.isMobile && isShare,
	      showClientShare: false };
	  },
	
	
	  vuex: {
	    getters: {
	      configInfo: function configInfo(state) {
	        return state.todo.configInfo;
	      },
	      isLoading: function isLoading(state) {
	        return state.todo.isLoading;
	      },
	      errorShow: function errorShow(state) {
	        return state.todo.errorShow;
	      },
	      errorInfo: function errorInfo(state) {
	        return state.todo.errorInfo;
	      },
	      todoList: function todoList(state) {
	        return state.todo.todoList;
	      }
	    },
	    actions: {
	      getConfigInfo: _actions.getConfigInfo,
	      getTodos: _actions.getTodos,
	      errorShowAction: _actions.errorShowAction,
	      updateConfigInfo: _actions.updateConfigInfo,
	      setDocTitle: _actions.setDocTitle
	    }
	  },
	
	  route: {
	    data: function data(transition) {
	      var _this = this;
	
	      this.getConfigInfo().then(function (res) {
	        var isWeChat = navigator.userAgent.indexOf('MicroMessenger') > 0;
	        var isShare = _this.$route.name === 'share';
	        if (window.HuobanAppSDK.isClient || isWeChat && !isShare) {
	          _this.showClientShare = true;
	        }
	        if (res && res.title) {
	          _this.setDocTitle(res.title);
	          if (_this.isWeChat) {
	
	            if (_this.isShare) {
	              _this.setInShare(res);
	            } else {
	              _this.setInClient(res);
	            }
	          }
	        }
	      });
	      transition.next();
	    }
	  },
	
	  ready: function ready() {
	    this.client = window.HuobanAppSDK.client();
	    if (this.isPC && document.body.className === '') {
	      document.body.className = document.body.className + 'isPC';
	    }
	    if (this.isMobile && document.body.className === '') {
	      document.body.className = document.body.className + 'isMobile';
	    }
	    if (this.isShare) {
	      this.hasCreate = true;
	    }
	  },
	
	
	  computed: {
	    comTitle: function comTitle() {
	      return this.configInfo.title;
	    },
	    comShareUrl: function comShareUrl() {
	      return this.configInfo.url;
	    },
	    styleObject: function styleObject() {
	      var ret = {};
	      if (this.isShowDialog) {
	        ret.display = 'block';
	      }
	      return ret;
	    },
	    styleQrcodeObject: function styleQrcodeObject() {
	      var ret = {};
	      if (this.isShowQrcode) {
	        ret.display = 'block';
	      }
	      return ret;
	    }
	  },
	
	  methods: {
	    setInShare: function setInShare(res) {
	      var _this2 = this;
	
	      (0, _actions.weChatAjax)().then(function (resq) {
	        if (resq) {
	          (0, _actions.wxConfig)(resq.data);
	          (0, _actions.wxReady)(function () {
	            var title = res.title;
	            var url = res.url;
	            if (!_lodash2.default.isEmpty(_this2.todoList)) {
	              var content = _this2.todoList[0].todo_content;
	              (0, _actions.onMenuShareAppMessage)(title, url, content);
	              (0, _actions.onMenuShareTimeline)(url, content);
	            } else {
	              _this2.getTodos().then(function (result) {
	                if (!_lodash2.default.isEmpty(result)) {
	                  var _content = result[0].todo_content;
	                  (0, _actions.onMenuShareAppMessage)(title, url, _content);
	                  (0, _actions.onMenuShareTimeline)(url, _content);
	                } else {
	                  var _content2 = '极简清单';
	                  (0, _actions.onMenuShareAppMessage)(title, url, _content2);
	                  (0, _actions.onMenuShareTimeline)(url, _content2);
	                }
	              });
	            }
	          });
	        }
	      });
	    },
	    setInClient: function setInClient(res) {
	      var _this3 = this;
	
	      this.getTodos().then(function (result) {
	        _this3.client.openShare({
	          title: _this3.comTitle,
	          content: _this3.todoList.length ? _this3.todoList[0].todo_content : '极简清单',
	          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
	          url: _this3.comShareUrl
	        }, function (data, error) {
	          _this3.closeMask();
	        });
	      });
	    },
	    closeMask: function closeMask() {
	      this.showMask = false;
	    },
	    openClientShare: function openClientShare() {
	      var _this4 = this;
	
	      if (this.isWeChat && !this.isShare) {
	        this.showMask = true;
	        this.client.openShare({
	          title: this.comTitle,
	          content: this.todoList.length ? this.todoList[0].todo_content : '极简清单',
	          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
	          url: this.comShareUrl
	        }, function (data, error) {
	          _this4.closeMask();
	        });
	      } else {
	        this.client.openShare({
	          title: this.comTitle,
	          content: this.todoList.length ? this.todoList[0].todo_content : '极简清单',
	          image: 'https://oaaqymp5v.qnssl.com/todo/152icon.png',
	          url: this.comShareUrl
	        });
	      }
	    },
	    handleShowQrcodeDialog: function handleShowQrcodeDialog() {
	      if (!this.configInfo) {
	        return;
	      }
	      if (this.isShowDialog) {
	        this.isShowDialog = false;
	        this.isShowQrcode = false;
	      } else {
	        this.isShowDialog = true;
	        this.qrcode = this.client.generateQrcode(this.configInfo.url);
	      }
	    },
	    handleShowQrcode: function handleShowQrcode() {
	      if (this.qrcode) {
	        if (this.isShowQrcode) {
	          this.isShowQrcode = false;
	        } else {
	          this.isShowQrcode = true;
	        }
	      }
	    },
	    handleCopy: function handleCopy() {
	      document.getElementById('share_url').select();
	      document.execCommand('Copy');
	    },
	    redirectToHuoban: function redirectToHuoban() {
	      var url = 'https://m.huoban.com/preinstall?preInsA10Id=11007';
	      location.href = url;
	    },
	    handleTitleChange: function handleTitleChange(text) {
	      if (text) {
	        var param = {
	          title: text
	        };
	        this.updateConfigInfo(param);
	      }
	    }
	  },
	
	  beforeDestroy: function beforeDestroy() {}
	};

/***/ },
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 47 */,
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/404.4638727.png";

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/error.09dc264.png";

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = " <div> <router-view v-if=isRender></router-view> <div class=mod_loader v-if=!isRender><span class=loader></span></div> </div> ";

/***/ },
/* 51 */
/***/ function(module, exports) {

	module.exports = " <div class=page_tips v-show=show>{{info}}</div> ";

/***/ },
/* 52 */
/***/ function(module, exports) {

	module.exports = " <div v-el:c :class=\"{'value':true , 'sort-handle': true}\" contenteditable=true :placeholder=placeholder @paste=handlePaste @keydown=handleKeyDown @focus=handleFocus @blur=handleBlur @click=handleClick></div> ";

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = " <div v-el:c :class=\"{'value':true}\" contenteditable=true :placeholder=placeholder @paste=handlePaste @keydown=handleKeyDown @focus=handleFocus @blur=handleBlur @click=handleClick></div> ";

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = " <div class=drag><i>&#xe906;</i></div> <div class=checkbox v-if=isFinished> <i @click=handleClick>&#xe901;</i> </div> <div class=checkbox v-else> <i @click=handleClick>&#xe900;</i> </div> <input-box :text=item.todo_content :is-finished=isFinished :item-id=item.item_id @input-box-change=handleInputBoxChange :index=index></input-box> ";

/***/ },
/* 55 */
/***/ function(module, exports) {

	module.exports = " <div class=todo_list> <div class=list_loading v-if=isLoadingList> <span></span> <span></span> <span></span> </div> <ol class=cl v-sortable=sortOption v-if=!isLoadingList v-el:sort-list> <li v-for=\"item in todoList\" :class=\"{finish: item.todo_status == 'completed'}\"> <todo-item :item=item :index=$index @delete-succeed=handleOperateSucceed @update-succeed=handleOperateSucceed></todo-item> </li> </ol> <div v-el:cover-ele v-show=isCover style=\"position: absolute ;opacity: 0\"></div> <div class=create> <div class=checkbox><i>&#xe900;</i></div> <todo-create :placeholder=\"'我想...'\" @input-box-change=handleInputBoxChange></todo-create> </div> </div> ";

/***/ },
/* 56 */
/***/ function(module, exports) {

	module.exports = " <div class=title contenteditable=true @paste=handlePaste @keydown=handleKeyDown @focus=handleFocus @blur=handleBlur></div> ";

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = " <div class=page_error> <img src=" + __webpack_require__(48) + " v-if=\"$route.query.type === '404'\"/> <div class=error_tips v-if=\"$route.query.type === 'error'\"> <img src=" + __webpack_require__(49) + " /> <p><span>加载应用数据失败！</span><a href=# @click.prevent=backToPrevRouter()>重新加载</a></p> </div> </div> ";

/***/ },
/* 58 */
/***/ function(module, exports) {

	module.exports = " <div class=wrap> <error-tip v-if=errorShow :show=errorShow :info=errorInfo></error-tip> <div class=todobox> <div class=todo_dialog_share v-bind:style=styleObject v-if=!isShare> <h3>分享清单</h3> <div class=url> <button @click.prevent=handleCopy()>复制连接</button> <i @click=handleShowQrcode()>&#xe904;</i> <input type=text :value=comShareUrl id=share_url /> </div> <div class=qrcode v-bind:style=styleQrcodeObject> <img :src=qrcode /> </div> </div> <div class=todo_dialog_share style=\"width:248px; margin-left: 200px; padding:0; height: auto\" v-bind:style=styleObject v-if=isShare> <img :src=qrcode /> </div> <div class=todo_sidebar> <a href=# @click.prevent=handleShowQrcodeDialog()> <i>&#xe903;</i> <span>分享</span> </a> <a href=# class=create @click.prevent=redirectToHuoban() v-if=hasCreate> <i>&#xe902;</i> <span>新建</span> </a> </div> <div class=todo_form> <div class=todo_create v-if=showCreateList> <a href=# @click.prevent=redirectToHuoban()><span>新建一个清单</span><i>&#xe905;</i></a> </div> <div class=todo_create v-if=showClientShare> <a href=# @click.prevent=openClientShare()><span>分享清单</span></a> </div> <div class=todo_title> <todo-title :text.sync=comTitle @title-box-change=handleTitleChange></todo-title> </div> <div class=todo_list> <todo-list></todo-list> </div> </div> <div class=todo_foot> <p><a href=#>©云表格·极简清单</a></p> </div> <div v-if=showMask @click=closeMask()> <div class=wechat_tips><span>分享清单给好友</span></div> <div class=mask></div> </div> </div> </div> ";

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(46)
	__vue_script__ = __webpack_require__(23)
	__vue_template__ = __webpack_require__(50)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(24)
	__vue_template__ = __webpack_require__(51)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(26)
	__vue_template__ = __webpack_require__(53)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(27)
	__vue_template__ = __webpack_require__(54)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(28)
	__vue_template__ = __webpack_require__(55)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(29)
	__vue_template__ = __webpack_require__(56)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(30)
	__vue_template__ = __webpack_require__(57)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ },
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.46c9dc56cfde659a8995.js
 **/